import {Formik} from "../../../../__snowpack__/pkg/formik.js";
import React, {useCallback} from "react";
import FormActions from "./form-actions.component.js";
import {getFirstErrorName} from "./form.functions.js";
import {FormContentContainer, FormFieldsetContainer, FormHtmlContainer} from "./form.styles.js";
function Form({
  children,
  defaultButtons,
  actionButtons,
  initialValues = {},
  validationSchema,
  innerRef,
  onCancel,
  onSubmit,
  onError
}) {
  const formikSubmitAction = useCallback(({
    setSubmitting
  }) => {
    setSubmitting(false);
  }, []);
  const formikSubmit = useCallback((values, formikHelpers) => {
    if (onSubmit) {
      const result = onSubmit(values);
      if (result && result.finally) {
        return result.finally(() => {
          formikSubmitAction(formikHelpers);
        });
      }
    }
    formikSubmitAction(formikHelpers);
  }, [formikSubmitAction, onSubmit]);
  const formikFn = useCallback(({
    handleSubmit,
    handleReset,
    isSubmitting,
    errors,
    isValid
  }) => {
    if (isSubmitting && !isValid) {
      const name = getFirstErrorName(errors);
      document.getElementsByName(name).item(0)?.scrollIntoView({
        behavior: "auto",
        block: "center",
        inline: "center"
      });
      if (onError) {
        onError(errors);
      }
    }
    return /* @__PURE__ */ React.createElement(FormHtmlContainer, {
      onSubmit: handleSubmit,
      onReset: handleReset,
      noValidate: true
    }, /* @__PURE__ */ React.createElement(FormFieldsetContainer, null, /* @__PURE__ */ React.createElement(FormContentContainer, null, children)), defaultButtons && /* @__PURE__ */ React.createElement(FormActions, {
      isSubmitting,
      actionButtons,
      onCancel
    }));
  }, [actionButtons, children, defaultButtons, onCancel, onError]);
  return /* @__PURE__ */ React.createElement(Formik, {
    innerRef,
    initialValues,
    validationSchema,
    onSubmit: formikSubmit
  }, formikFn);
}
export default /* @__PURE__ */ React.memo(Form);
